import React from 'react'
import { Tooltip } from '@material-ui/core'

const TruncatedText = ({ text, maxLength = 50 }) => {
  return text.length > maxLength ? (
    <Tooltip title={text} placement="bottom-end">
      <span className="truncate cursor-pointer">
        {text.substring(0, maxLength)}...
      </span>
    </Tooltip>
  ) : (
    <span className="truncate" title={text}>
      {text}
    </span>
  )
}

export default TruncatedText
